import React from 'react';
import { LanguageProvider } from './context/LanguageContext';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { AboutUs } from './components/AboutUs';
import { Services } from './components/Services';
import { Calendar } from './components/Calendar';
import { Contact } from './components/Contact';
import { TermsOfService } from './components/TermsOfService';
import { Footer } from './components/Footer';
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-[#FAF7F5]" data-id="element-1">
        <Navbar data-id="element-2" />
        <main data-id="element-3">
          <Hero data-id="element-4" />
          <AboutUs data-id="element-5" />
          <Services data-id="element-6" />
          <Calendar data-id="element-7" />
          <Contact data-id="element-8" />
          <TermsOfService data-id="element-9" />
        </main>
        <Footer data-id="element-10" />
      </div>
    </LanguageProvider>;
}